module.exports = __webpack_public_path__ + "img/42.b6b81e46.jpg";